import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleReportsPageTourConfig: AgTechTourConfig = {
    id: 'sale-reports-page-tour',
    name: 'Reports Tour',
    steps: [
        {
            targetId: 'sale-reports-sale-section',
            title: 'Sale Reports',
            description: 'High-level views of the sale\'s overall performance — including bidder activity summaries and sale results.',
            position: 'bottom',
        },
        {
            targetId: 'sale-reports-lots-section',
            title: 'Lots Reports',
            description: 'Detailed reports on your lot inventory — lot summaries, sale order listings, and lot status breakdowns.',
            position: 'bottom',
        },
        {
            targetId: 'sale-reports-financial-section',
            title: 'Financial Reports',
            description: 'Settlement sheets, buyer invoices, and financial summaries. Use these to reconcile payments and share results with buyers and sellers.',
            position: 'bottom',
        },
    ]
}
